import React, {useState} from 'react';
import Select from "react-select";
import pokedex from '../../../../pokedex.json';

const PokemonPicker = (props) => {
	const [search, setSearch] = useState('');
	const options = pokedex.map(p => {return {value: p.pokemon_id, label: p.name}; });

	const filterOptions = (candidate, input) => {
		return candidate.label.toLowerCase().startsWith(input.toLowerCase());
	};

	const onChange = (event) => {
		props.onPokemonSelected(event);
		props.setValue('');
	};

	return (
		<>
			<Select
				value={search}
				options={options}
				onChange={props.onPokemonSelected}
				filterOption={filterOptions}
				placeholder="Choose Pokemon..." />
		</>
	);
};

export default PokemonPicker;